import * as angular from 'angular';
import { bootstrapAppWhenReady } from './bootstrap';

bootstrapAppWhenReady('lpInvalidApp');

angular.module('lpInvalidApp', ['wixShoutoutTranslations', 'wix.common.bi', 'wixAngular']).run(function () {});
